import type { EnrichedAnimalCategory } from "shared/types";
import {
  LIST_ENRICHED_FARM_CATEGORIES,
  type CategoryDispatchAction,
} from "../actions/categoryActions";

export type CategoryState = {
  enrichedFarmCategories: EnrichedAnimalCategory[];
};

export const initialState: CategoryState = {
  enrichedFarmCategories: [],
};

function categoryReducer(
  state = initialState,
  action: CategoryDispatchAction
): CategoryState {
  if (action.type === LIST_ENRICHED_FARM_CATEGORIES) {
    return {
      ...state,
      enrichedFarmCategories: action.payload.categories,
    };
  }
  return { ...state };
}

export default categoryReducer;
